import React from 'react';
import {Col} from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {PulseLoader} from 'react-spinners';
import {COLORS} from '../../constants';

export const AttributeDiv = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
`;

const Input = styled.input`
  background: ${({disabled}) => disabled ? COLORS.BACKGROUND_GRAY : COLORS.WHITE};
  font-size: 14px;
`;

const InputCol = ({title, size, loading, onChange, type, value, tReady, labelStyle, Component, disabled, ...inputProps}) => {
  return (
    <Col xs={size}>
      <label style={labelStyle}>
        <AttributeDiv className="label-name">{title}</AttributeDiv>
        {loading ? (
          <PulseLoader loading={loading} />
        ) : (
          <Component
            type={type}
            value={value}
            onChange={e => onChange(inputProps.name, e.target.value)}
            disabled={disabled}
            {...inputProps}
          />
        )}
      </label>
    </Col>
  );
};

InputCol.defaultProps = {
  size: 12,
  loading: false,
  type: 'text',
  value: '',
  labelStyle: {},
  onChange: () => {},
  disabled: false,
  Component: Input,
};

InputCol.propTypes = {
  title: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.any,
  labelStyle: PropTypes.object,
  disabled: PropTypes.bool,
  Component: PropTypes.any,
};

export default InputCol;
